module.exports = __webpack_public_path__ + "static/media/mb2v.b80a8b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb2v.png
// module id = 197
// module chunks = 0